import { render, staticRenderFns } from "./Workshops.vue?vue&type=template&id=5e29a197&scoped=true&"
import script from "./Workshops.vue?vue&type=script&lang=js&"
export * from "./Workshops.vue?vue&type=script&lang=js&"
import style0 from "./Workshops.vue?vue&type=style&index=0&id=5e29a197&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e29a197",
  null
  
)

export default component.exports